import { render, staticRenderFns } from "./LpuPhotos.vue?vue&type=template&id=79e1887d&scoped=true&"
import script from "./LpuPhotos.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuPhotos.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuPhotos.vue?vue&type=style&index=0&id=79e1887d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e1887d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79e1887d')) {
      api.createRecord('79e1887d', component.options)
    } else {
      api.reload('79e1887d', component.options)
    }
    module.hot.accept("./LpuPhotos.vue?vue&type=template&id=79e1887d&scoped=true&", function () {
      api.rerender('79e1887d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPhotos/LpuPhotos.vue"
export default component.exports